// src/deep-link/constants.ts
var DEEP_LINK_PROTOCOL = "copera://";
var DeepLinkEntity = /* @__PURE__ */ ((DeepLinkEntity2) => {
  DeepLinkEntity2["Url"] = "url";
  DeepLinkEntity2["PrivateImage"] = "private-image";
  DeepLinkEntity2["User"] = "mentionUser";
  DeepLinkEntity2["Doc"] = "mentionDoc";
  DeepLinkEntity2["Transcription"] = "transcription";
  DeepLinkEntity2["TableRow"] = "table-row";
  return DeepLinkEntity2;
})(DeepLinkEntity || {});

// src/deep-link/isDeepLink.ts
var isDeepLink = (href) => {
  return href == null ? void 0 : href.startsWith(DEEP_LINK_PROTOCOL);
};

// src/deep-link/routes/doc.ts
var createDocDeepLink = (data) => {
  return `${DEEP_LINK_PROTOCOL}${"mentionDoc" /* Doc */}/${data.id}`;
};
var deserializeDocDeepLink = (url) => {
  const [, id] = url.pathname.split("/");
  return {
    type: "mentionDoc" /* Doc */,
    id
  };
};

// src/deep-link/createSearchParams.ts
var createSearchParams = (params) => {
  const paramsString = Object.entries(params).filter(
    ([, value]) => value !== void 0 && value !== null && value !== ""
  ).map(([key, value]) => `${key}=${value}`).join("&");
  return paramsString ? `?${paramsString}` : "";
};

// src/deep-link/routes/private-image.ts
var createPrivateImageDeepLink = (data) => {
  const params = createSearchParams({
    width: data.width,
    height: data.height
  });
  return `${DEEP_LINK_PROTOCOL}${"private-image" /* PrivateImage */}/${data.id}${params}`;
};
var deserializePrivateImageDeepLink = (url) => {
  const [, id] = url.pathname.split("/");
  return {
    type: "private-image" /* PrivateImage */,
    id,
    width: url.searchParams.get("width"),
    height: url.searchParams.get("height")
  };
};

// src/deep-link/routes/public-image.ts
var createPublicImageDeepLink = (data) => {
  const params = createSearchParams({
    width: data.width,
    height: data.height
  });
  return `${data.src}${params}`;
};
var deserializePublicImageDeepLink = (url) => {
  return {
    type: "url" /* Url */,
    src: url.href,
    width: url.searchParams.get("width"),
    height: url.searchParams.get("height")
  };
};

// src/deep-link/routes/table-row.ts
var createTableRowDeepLink = (data) => {
  const params = createSearchParams({
    tableId: data.tableId,
    boardId: data.boardId
  });
  return `${DEEP_LINK_PROTOCOL}${"table-row" /* TableRow */}/${data.rowId}${params}`;
};
var deserializeTableRowDeepLink = (url) => {
  const [, rowId] = url.pathname.split("/");
  return {
    type: "table-row" /* TableRow */,
    rowId,
    tableId: url.searchParams.get("tableId") || "",
    boardId: url.searchParams.get("boardId") || ""
  };
};

// src/deep-link/routes/transcription.ts
var createTranscriptionDeepLink = (data) => {
  return `${DEEP_LINK_PROTOCOL}${"transcription" /* Transcription */}/${data.parentDocId}`;
};
var deserializeTranscriptionDeepLink = (url) => {
  const [, parentDocId] = url.pathname.split("/");
  return {
    type: "transcription" /* Transcription */,
    parentDocId
  };
};

// src/deep-link/routes/user.ts
var createUserDeepLink = (data) => {
  return `${DEEP_LINK_PROTOCOL}${"mentionUser" /* User */}/${data.id}`;
};
var deserializeUserDeepLink = (url) => {
  const [, id] = url.pathname.split("/");
  return {
    type: "mentionUser" /* User */,
    id
  };
};

// src/deep-link/deep-link-parser.ts
var handlers = {
  ["private-image" /* PrivateImage */]: {
    create: createPrivateImageDeepLink,
    deserialize: deserializePrivateImageDeepLink
  },
  ["url" /* Url */]: {
    create: createPublicImageDeepLink,
    deserialize: deserializePublicImageDeepLink
  },
  ["mentionDoc" /* Doc */]: {
    create: createDocDeepLink,
    deserialize: deserializeDocDeepLink
  },
  ["mentionUser" /* User */]: {
    create: createUserDeepLink,
    deserialize: deserializeUserDeepLink
  },
  ["transcription" /* Transcription */]: {
    create: createTranscriptionDeepLink,
    deserialize: deserializeTranscriptionDeepLink
  },
  ["table-row" /* TableRow */]: {
    create: createTableRowDeepLink,
    deserialize: deserializeTableRowDeepLink
  }
};
var serializeDeepLink = (data) => {
  const handler = handlers[data.type];
  if (!handler) throw new Error(`No handler found for type: ${data.type}`);
  return handler.create(data);
};
var deserializeDeepLink = (href) => {
  if (!isDeepLink(href)) return null;
  const url = new URL(href);
  const handler = handlers[url.hostname];
  if (!handler) throw new Error(`No handler found for type: ${url.hostname}`);
  return handler.deserialize(url);
};

export { DeepLinkEntity, deserializeDeepLink, isDeepLink, serializeDeepLink };
